import React, { useContext, useState, useEffect, useMemo } from "react";
import { Alert as AlertComponent } from '@aidkitorg/component-library';
import InterfaceContext from "../Context";
import { safeParse, useMarkdown } from "../Util";
import { QuestionProps } from "./Props";

export function Alert(props: QuestionProps) {
  const context = useContext(InterfaceContext);
  const { content, slugs, variant, dismissible, title, iconName, mode } = safeParse(props.Metadata ?? "{}", {});
  return <AlertComponent
    variant={variant}
    title={title}
    mode={mode}
    dismissible={dismissible}
    iconName={iconName}>
    {useMarkdown(content[context.lang] ?? content["en"], false, true)}
  </AlertComponent>;
}
